import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import NavMenu from '@/components/NavMenu'
import controlPanel from '@/pages/controlPanel/controlPanel.vue'
import filesManage from '@/pages/filesManage/filesManage.vue'
import houseResource from '@/pages/houseResource/houseResource.vue'
import houseResourceEdit from '@/pages/houseResource/components/houseResourceEdit.vue'
import houseResourceMessage from '@/pages/houseResource/components/houseResourceMessage.vue'
import message from '@/pages/message/message.vue'
import publishHouse from '@/pages/publishHouse/publishHouse.vue'
import login from '@/pages/login/login.vue'
Vue.use(Router)

// const NavMenu = r => require.ensure([], () => r(require('@/components/NavMenu')), 'NavMenu');
export default new Router({
	routes: [
		{
            path: '/',
            component: login,
			name: 'login',
        },
		{
            path: '/login',
            component: login,
			name: 'login',
        },
		{
			path: '/NavMenu',
			name: 'NavMenu',
			component: NavMenu,
			children: [{
				path: '/controlPanel',
				name: 'controlPanel',
				component: controlPanel,
			},{
				path: '/filesManage',
				name: 'filesManage',
				component: filesManage,
			},{
				path: '/houseResource',
				name: 'houseResource',
				component: houseResource,
				children:[
					{
						path: '/houseResource/houseResourceMessage',
						name: 'houseResourceMessage',
						component: houseResourceMessage,
					},
					{
						path: '/houseResource/houseResourceEdit',
						name: 'houseResourceEdit',
						component: houseResourceEdit,
					}
				]
			},{
				path: '/message',
				name: 'message',
				component: message,
			},{
				path: '/publishHouse',
				name: 'publishHouse',
				component: publishHouse,
			}]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js